import {combineReducers, configureStore, PreloadedState} from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {cdiDetailSlice} from "../services/cdiDetailSlice";
import {clApiSlice} from "../services/clApiSlice";
import {environmentTypeSlice} from "../services/environmentTypeSlice";
import {userSlice} from "../services/userSlice";
import {designItemsSlice} from "../services/designItemsSlice";
import {searchQueryFilterSlice} from "../services/searchQueryFilterSlice";
import {seqApiSlice} from "../services/seqApiSlice";
import {seqDataSlice} from "../services/seqDataSlice";
import {localizationSlice} from "../services/localizationSlice";
import {sceneSlice} from "../services/sceneSlice";

const persistConfig = {
	key: "root",
	version: 1,
	storage,
	whitelist: ["localization", "searchQuery", "userInformations"],
};

export const rootReducer = combineReducers({
	seqData: seqDataSlice.reducer,
	item: cdiDetailSlice.reducer,
	environmentType: environmentTypeSlice.reducer,
	userInformations: userSlice.reducer,
	items: designItemsSlice.reducer,
	itemsLite: designItemsSlice.reducer,
	searchQueryFilter: searchQueryFilterSlice.reducer,
	localization: localizationSlice.reducer,
	[clApiSlice.reducerPath]: clApiSlice.reducer,
	[seqApiSlice.reducerPath]: seqApiSlice.reducer,
	[sceneSlice.reducerPath]: sceneSlice.reducer,
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);

export function setupStore(preloadedState?: PreloadedState<RootState>) {
	return configureStore({
		reducer: persistedReducer,
		middleware: (getDefaultMiddleware) => {
			return getDefaultMiddleware({serializableCheck: false}).concat(
				clApiSlice.middleware,
				seqApiSlice.middleware,
				sceneSlice.middleware,
			);
		},
		preloadedState,
	});
}

export type RootState = ReturnType<typeof persistedReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
